import React from "react";
import { Header } from "../../components/Header";
import { JoinusBanner } from "../../blocks/joinus-banner/index";
import "./styles.less";
import { Footer } from "../../components/FooterV2";
import { JoinusExperience } from "../../blocks/joinus-experience";
import { JoinusWalfare } from "../../blocks/joinus-walfare";
import { JoinusJobs } from "../../blocks/joinus-jobs";
import { HomeTryOn } from "../../blocks/home-try-on";
import { Helmet } from "react-helmet";
import { Notice } from "../../components/Notice";

export const JoinusPage = () => {
  return (
    <div className="joinus-page">
      <Helmet>
        <title>Authing招聘-加入Authing-Authing身份云</title>
      </Helmet>
      <Header />
      <JoinusBanner />
      {/* <JoinusExperience /> */}
      <JoinusWalfare />
      <JoinusJobs />
      <HomeTryOn />
      <Footer />
    </div>
  );
};
